import React, { useRef, useState } from "react";
import { Ripple } from "primereact/ripple";
import styles from "./QuickStart.module.css";

const QuickStartPage = () => {
  const [isHidden, setIsHidden] = useState(true);
  const [expandedSection, setExpandedSection] = useState(null);
  const menuRef = useRef(null);

  const toggleMenuItemClick = (e) => {
    e.preventDefault();
    setIsHidden((prevState) => !prevState);
  };

  const toggleSection = (section) => {
    setExpandedSection((prev) => (prev === section ? null : section));
  };

  const getImagePath = (imageName) => {
    return process.env.PUBLIC_URL + "/images/" + imageName;
  };

  return (
    <div className={`${styles.pageContainer} relative`}>
      <div
        className={`${styles.container} relative overflow-hidden flex flex-column`}
      >
        {/* Navigation */}
        <div className={`${styles.navigation} px-4 md:px-8 py-4 relative`}>
          <div className="flex align-items-center justify-content-between w-full">
            {/* Logo on far left */}
            <div className="flex align-items-center select-none">
              <a href="/app">
                <img
                  src={getImagePath("headerlogo2.png")}
                  alt="Interesting"
                  className={styles.headerLogo}
                />
              </a>
            </div>

            {/* Mobile menu toggle - only visible on mobile */}
            <button
              onClick={toggleMenuItemClick}
              className="cursor-pointer block lg:hidden border-none bg-transparent p-2"
              type="button"
              aria-label="Toggle menu"
            >
              <i className={`${styles.mobileMenuIcon} pi pi-bars text-2xl`}></i>
            </button>

            {/* Desktop Navigation */}
            <div
              className={`${styles.desktopNav} hidden lg:flex align-items-center justify-content-between`}
            >
              {/* Center menu items */}
              <div className="flex align-items-center justify-content-center flex-grow-1">
                <ul className="list-none p-0 m-0 flex align-items-center select-none">
                  <li className="mx-3">
                    <a href="/app/offering" className={`${styles.menuItem}`}>
                      <span>Offering</span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="mx-3">
                    <a
                      href="/app/pricing"
                      className={`${styles.menuItem} ${styles.activeMenuItem}`}
                    >
                      <span>Pricing</span>
                      <Ripple />
                    </a>
                  </li>
                  {/* <li className="mx-3">
                    <a href="#why-us" className={`${styles.menuItem}`}>
                      <span>Why us</span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="mx-3">
                    <a href="#ting" className={`${styles.menuItem}`}>
                      <span>Ting</span>
                      <Ripple />
                    </a>
                  </li> */}
                  <li className="mx-3">
                    <a href="/app/contact" className={`${styles.menuItem}`}>
                      <span>Contact us</span>
                      <Ripple />
                    </a>
                  </li>
                </ul>
              </div>

              {/* CTA button on far right */}
              <div className="flex align-items-center">
                <a
                  href="https://app.interestng.com/app/login"
                  className={styles.heroCta1}
                >
                  Login
                  <Ripple />
                </a>
              </div>
            </div>

            {/* Mobile menu - only shows on mobile when toggled */}
            {!isHidden && (
              <div
                className={`${styles.mobileMenu} block lg:hidden absolute top-full left-0 w-full shadow-2`}
              >
                <ul className="list-none p-0 m-0 flex flex-column">
                  <li>
                    <a
                      href="/app/offering"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Offering</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="/app/pricing"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Pricing</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#why-us"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Why us</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#ting"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Ting</span>
                      <Ripple />
                    </a>
                  </li>
                  <li>
                    <a
                      href="/app/contact"
                      className={`${styles.mobileMenuItem} p-ripple flex px-4 py-3 align-items-center font-medium cursor-pointer`}
                    >
                      <span>Contact us</span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="p-3">
                    <a
                      href="https://app.interestng.com/app/login"
                      className={styles.ctaButton2}
                    >
                      Login
                      <Ripple />
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* Breadcrumb */}
        <div className={`${styles.breadcrumb} px-4 md:px-8 py-3`}>
          <div className="flex align-items-center">
            <a href="/app/pricing" className={styles.breadcrumbLink}>
              <i className="pi pi-chevron-left mr-2"></i>
              Back
            </a>
            <span className={styles.breadcrumbSeparator}>|</span>
            <a
              href="/app/quick-start"
              className={`${styles.breadcrumbLink} ${styles.breadcrumbActive}`}
            >
              Quick Start
            </a>
            <span className={styles.breadcrumbSeparator}>|</span>
            <a href="/app/standard" className={styles.breadcrumbLink}>
              Standard
            </a>
            <span className={styles.breadcrumbSeparator}>|</span>
            <a href="/app/premium" className={styles.breadcrumbLink}>
              Premium
            </a>
            <span className={styles.breadcrumbSeparator}>|</span>
            <a href="/app/enterprise" className={styles.breadcrumbLink}>
              Enterprise
            </a>
          </div>
        </div>
        {/* Main Content */}
        <div className={styles.allSectionsContainer}>
          {/* Plan Header */}
          <div className={`${styles.planHeader} px-4 md:px-8 py-6 text-center`}>
            <h1 className={styles.planTitle}>Quick Start</h1>
          </div>

          {/* Plan Card Section */}
          <div className={`${styles.planCardSection} px-4 md:px-8 pb-8`}>
            <div className="flex justify-content-center">
              <div className={styles.planDetailCard}>
                <div className={styles.cardTopSection}>
                  <div className="text-center mb-4">
                    <h3 className={styles.planCardDescription}>
                      Earn from your connects
                    </h3>
                    <p className={styles.planCardSubtext}>
                      More connects more
                      <br />
                      earnings
                    </p>
                  </div>

                  <div className={`${styles.priceContainer} text-center mb-4`}>
                    <span className={styles.rupeeSymbol}>₹</span>
                    <span className={styles.priceAmount}>0</span>
                  </div>

                  <div className={styles.referralInfo}>
                    <p className={styles.referralItem}>
                      <span className={styles.checkMark}>✓</span>
                      <span>Earn Referral Payout from 0.25% to 2.25%</span>
                    </p>
                    <br />
                    <p className={styles.referralItem}>
                      <span className={styles.checkMark}>✓</span>
                      <span>
                        Access to Pay as you use verification features
                      </span>
                    </p>
                  </div>
                </div>

                {/* Free Features */}
                <div className={styles.featuresSection}>
                  <div className="text-center mb-4">
                    <button
                      className={`${styles.planButton} ${styles.quickStartButton}`}
                    >
                      Start with Quick Start
                      <Ripple />
                    </button>
                  </div>

                  <p className={styles.featuresTitle}>Free Features:</p>
                  <ul className={styles.featuresList}>
                    <li>• Compare & share multiple bank offers</li>
                    <li>• Track loan status & approvals easily</li>
                    <li>• Referral payouts visibility on disbursals</li>
                    <li>• Onboard quickly to bank</li>
                    <li>• Pay as you use for third party Verification APIs</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Expandable Sections */}
          <div className={styles.expandableSection}>
            <div className="flex justify-content-center">
              <div className={styles.expandableContainer}>
                {/* Who is it for? */}
                <div className={styles.expandableItem}>
                  <button
                    className={styles.dropdownToggle}
                    onClick={() => toggleSection("whoFor")}
                  >
                    <span>Who is it for?</span>
                    <i
                      className={`pi ${
                        expandedSection === "whoFor"
                          ? "pi-chevron-up"
                          : "pi-chevron-down"
                      }`}
                    ></i>
                  </button>
                  {expandedSection === "whoFor" && (
                    <div className={styles.expandableContent}>
                      <ul>
                        <li>• Those who wish to earn from a quick referral</li>
                        <li>• Any loan agent and DSA (explain acronym)</li>
                        <li>• Ex-bankers, Financial consultants, auditors</li>
                        <li>• HR in corporates</li>
                        <li>• Business correspondents</li>
                        <li>• Real estate builders</li>
                        <li>
                          • Resellers who want to arrange a loan for purchase of
                          their products (above 1 lakh)
                        </li>
                        <li>• Tally and Zoho distributors</li>
                        <li>
                          • Digital platforms owners to earn extra revenue
                        </li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* How it works? */}
                <div className={styles.expandableItem}>
                  <button
                    className={styles.dropdownToggle}
                    onClick={() => toggleSection("howWorks")}
                  >
                    <span>How it works?</span>
                    <i
                      className={`pi ${
                        expandedSection === "howWorks"
                          ? "pi-chevron-up"
                          : "pi-chevron-down"
                      }`}
                    ></i>
                  </button>
                  {expandedSection === "howWorks" && (
                    <div className={styles.expandableContent}>
                      <ul>
                        <li>• Sign up with Quick start plan</li>
                        <li>
                          • Submit lead, or optionally basic documents of
                          borrower
                        </li>
                        <li>• We handle the loan processing</li>
                        <li>• Earn revenue on loan disbursal</li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* When you should use it? */}
                <div className={styles.expandableItem}>
                  <button
                    className={styles.dropdownToggle}
                    onClick={() => toggleSection("whenUse")}
                  >
                    <span>When you should use it?</span>
                    <i
                      className={`pi ${
                        expandedSection === "whenUse"
                          ? "pi-chevron-up"
                          : "pi-chevron-down"
                      }`}
                    ></i>
                  </button>
                  {expandedSection === "whenUse" && (
                    <div className={styles.expandableContent}>
                      <ul>
                        <li>• To earn quick additional income</li>
                        <li>• Don't have enough time</li>
                        <li>• Don't have any resource</li>
                        <li>• Don't want to be perceived as a loan agent</li>
                      </ul>
                      <p className={styles.alsoWhenTitle}>Also When You:</p>
                      <ul>
                        <li>
                          • Need a loan expert to close a difficult loan deal
                        </li>
                        <li>
                          • To try for an approval when the case is rejected
                        </li>
                        <li>
                          • For a customer who needs direct banker involvement
                        </li>
                        <li>
                          • Borrower needs loan comparison and loan life cycle
                          analytics
                        </li>
                        <li>• For Instant payouts/Advance payout</li>
                        <li>
                          • Build your own channels of distribution and social
                          media.
                        </li>
                        <li>• For multi city loan distribution and training</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Features Comparison Section */}
          <div className={`${styles.comparisonSection} px-4 md:px-8 py-8`}>
            <h2 className={`${styles.comparisonTitle} text-center mb-6`}>
              Here's what you get in{" "}
              <span className={styles.blueText}>all plans</span>
            </h2>

            <div
              className={`${styles.featuresGrid} grid justify-content-center`}
            >
              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("get-money-svgrepo-com 1.png")}
                      alt="Loan products & schemes"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>
                    Loan products &<br />
                    schemes
                  </h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> Personal Loan
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Home Loan
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Business Loan
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Loan against Property
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("work-svgrepo-com-1.svg")}
                      alt="Banks & partners"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Banks & partners</h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> 12 Private banks
                    </li>
                    <li>
                      <i className="pi pi-check"></i> 4 Public Sector Banks
                    </li>
                    <li>
                      <i className="pi pi-check"></i> 40 NBFC
                    </li>
                    <li>
                      <i className="pi pi-check"></i> 5 Fintechs
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Banking Surrogates
                    </li>
                  </ul>
                  <p className={styles.andMore}>and more...</p>
                </div>
              </div>

              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("users-svgrepo-com (1) 1.png")}
                      alt="Borrowers we support"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Borrowers we support</h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> Salaried
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Self employed
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Family
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Partnership Firms
                    </li>
                    <li>
                      <i className="pi pi-check"></i> High Networth Individuals
                    </li>
                  </ul>
                  <p className={styles.andMore}>and more..</p>
                </div>
              </div>

              <div className="col-12 sm:col-6 md:col-3 p-3">
                <div className={styles.featureCard}>
                  <div className={styles.featureIcon}>
                    <img
                      src={getImagePath("path1 1.png")}
                      alt="Smart verifications"
                      className={styles.featureIconImage}
                    />
                  </div>
                  <h3 className={styles.featureTitle}>Smart verifications</h3>
                  <ul className={styles.featureList}>
                    <li>
                      <i className="pi pi-check"></i> Income
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Identity
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Employment
                    </li>
                    <li>
                      <i className="pi pi-check"></i> Business
                    </li>
                  </ul>
                  <p className={styles.andMore}>and more..</p>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {/* End of All Main Sections Container */}
        {/* Final CTA Section */}
        <div className={`${styles.finalCtaSection} relative`}>
          <div className={styles.ctaWaveBackground}></div>
          <div className={`${styles.ctaContent} px-4 md:px-8 py-8`}>
            <div className={`grid align-items-center ${styles.ctaGrid}`}>
              <div className={`col-12 md:col-8 ${styles.ctaTitleColumn}`}>
                <h2 className={`${styles.ctaTitle} mb-4 md:mb-0`}>
                  Let's Stop Losing Deals
                  <br className="hidden md:block" />
                  Together
                </h2>
              </div>
              <div className={`col-12 md:col-4 ${styles.ctaButtonColumn}`}>
                <a
                  href="https://app.interestng.com/app/login"
                  className={styles.ctaButton}
                >
                  Login
                  <Ripple />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className={styles.footer}>
          <div className="px-4 md:px-8 py-8">
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="mb-6">
                  <h3 className={styles.footerBrand}>
                    Interestng™ — Life is Dull
                    <br />
                    When You Lose Deals
                  </h3>
                  <div className={styles.footerLogoContainer}>
                    <img
                      src={getImagePath("footerLogo.svg")}
                      alt="Interesting Logo"
                      className={styles.footerLogoImage}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="grid">
                  <div className="col-4">
                    <ul className="list-none p-0 m-0">
                      <li className="mb-3">
                        <a
                          href="/app"
                          className={styles.footerLink}
                        >
                          Home
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/offering" className={styles.footerLink}>
                          Offering
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/pricing" className={styles.footerLink}>
                          Pricing
                        </a>
                      </li>
                      {/* <li className="mb-3">
                        <a href="#why-us" className={styles.footerLink}>
                          Why Us
                        </a>
                      </li> */}

                      <li className="mb-3">
                        <a href="#service" className={styles.footerLink}>
                          Service
                        </a>
                      </li>

                      <li className="mb-3">
                        <a href="#faq" className={styles.footerLink}>
                          FAQ
                        </a>
                      </li>

                      {/* <li className="mb-3">
                        <a href="#ting" className={styles.footerLink}>
                          Ting
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  <div className="col-4">
                    <ul className="list-none p-0 m-0">
                      {/* <li className="mb-3">
                        <a href="#faq" className={styles.footerLink}>
                          FAQ
                        </a>
                      </li> */}
                      <li className="mb-3">
                        <a href="/app/about" className={styles.footerLink}>
                          About Us
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="/app/contact" className={styles.footerLink}>
                          Contact us
                        </a>
                      </li>

                      <li className="mb-3">
                        <a
                          href="/app/terms-and-conditions"
                          className={styles.footerLink}
                        >
                          Terms & Conditions
                        </a>
                      </li>
                      <li className="mb-3">
                        <a
                          href="/app/privacy-policy"
                          className={styles.footerLink}
                        >
                          Privacy Policy
                        </a>
                      </li>
                      <li className="mb-3">
                        <a
                          href="/app/refund-policy"
                          className={styles.footerLink}
                        >
                          Refund-Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default QuickStartPage;
